import AscendingLogoGrey from "assets/img/illustrations/AscendingLogoGrey";
import DescendingLogoGrey from "assets/img/illustrations/DescendingLogoGrey";
import NoData from "assets/svgs/no_data/NoData";
import SoftBadge from "modules/common/SoftBadge";
import PaginationDiv from "modules/pagination/PaginationDiv";
import { currentUser, fourPlaceHolder } from "modules/utilities/utility";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

function AppointmentTable({ isLoading, tableData }) {
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [page, newPage] = useState(1);
  const [sortData, setSortedData] = useState([]);
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);
  const header = ["Name", "Payment Status", "Booking Time", "N/A Count"];
  const clinicDoctorHeader = ["Name", "Payment Status", "Booking Time"];
  const clinicDoctor = ["clinic_doctor"];

  useEffect(() => {
    setSortedData(tableData);
  }, [tableData]);
  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  const handleSort = () => {
    if (tableData?.length === 0) {
      return;
    }
    if (count === 0) {
      setOpa("dsc");
      setCount(1);
      setSortedData([
        ...tableData?.sort(
          (a, b) => moment(a?.slot_time) - moment(b?.slot_time)
        ),
      ]);
    } else if (count === 1) {
      setOpa("asc");
      setCount(2);
      setSortedData([
        ...tableData?.sort(
          (a, b) => moment(b?.slot_time) - moment(a?.slot_time)
        ),
      ]);
    } else if (count === 2) {
      setOpa("");
      setCount(0);
      setSortedData([...tableData]);
    }
  };

  const tableHead = clinicDoctor.includes(currentUser)
    ? clinicDoctorHeader
    : header;

  return (
    <div>
      <div
        className="mt-n1 shadow rounded mt-5 scrollable-container"
        style={{ maxHeight: "80vh", overflowY: "scroll" }}
      >
        <div
          className="d-flex table-head rounded-top "
          style={{ position: "sticky", top: "0" }}
        >
          {tableHead?.map((item) => {
            return (
              <span className="p-3 fw-bold text-black flex-1 border-end">
                {item}
              </span>
            );
          })}
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "relative", marginRight: "10rem" }}
                id="overlay-trigger-example"
              >
                {opa == "asc" ? (
                  <span className="fw-bold">Click to cancel Sort</span>
                ) : opa == "dsc" ? (
                  <span className="fw-bold">Click to sort Descending</span>
                ) : (
                  <span className="fw-bold">Click to Sort Ascending</span>
                )}
              </Tooltip>
            }
          >
            <span
              className="p-3 fw-bold text-black flex-1 text-center border-end cursor-pointer"
              onClick={handleSort}
            >
              <span
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
              >
                <span>Slot Time</span>
              </span>
              <div
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  paddingLeft: "1rem",
                }}
              >
                <div
                  className={
                    opa === ""
                      ? "opacity-100"
                      : opa === "asc"
                      ? "opacity-50"
                      : "opacity-100"
                  }
                >
                  <AscendingLogoGrey />
                </div>
                <div
                  className={
                    opa === ""
                      ? "opacity-100 mt-n2"
                      : opa === "dsc"
                      ? "opacity-50 mt-n2"
                      : "opacity-100 mt-n2"
                  }
                >
                  <DescendingLogoGrey />
                </div>
              </div>
            </span>
          </OverlayTrigger>
        </div>
        {isLoading ? (
          fourPlaceHolder()
        ) : filterData && filterData?.length ? (
          <div style={{ maxHeight: "65vh" }}>
            {filterData?.map((item, index) => {
              return (
                <div
                  className={`d-flex table-row border- border-top-0  ${
                    index === filterData?.length - 1 && `rounded-bottom`
                  }`}
                >
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    <Link to={`/lead-details/${item?.case_id}`}>
                      <span className="fw-bold"> {item?.name}</span>
                    </Link>
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {item?.payment_status && (
                      <SoftBadge
                        color={
                          item?.payment_status === "paid" ? "green" : "default"
                        }
                      >
                        <span className="fw-bold">
                          {item?.payment_status
                            .replaceAll("_", " ")
                            .toUpperCase()}
                        </span>
                      </SoftBadge>
                    )}
                  </span>
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {moment(item?.booking_time).format("DD MMM YYYY, h:mm a")}
                  </span>
                  {!clinicDoctor.includes(currentUser) && (
                    <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                      <span className="fw-bold"> {item?.unanswered_count}</span>
                    </span>
                  )}
                  <span className="p-3 flex-1 text-break text-black text-wrap border-end">
                    {moment(item?.slot_time).format("DD MMM YYYY, h:mm a")}
                  </span>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="p-3 bg-white rounded-bottom text-center">
            {" "}
            No Data Available <NoData />
          </div>
        )}
      </div>
      <PaginationDiv
        paginationData={{ pageCount: pageCount || 1, page: page }}
        newPage={newPage}
        activePage={page}
      />
    </div>
  );
}

export default AppointmentTable;
